<template>
    <div class="annOnLine">
        <annTab :type="0"></annTab>
        <div class="notLink" v-show="linkFlag">
            <img src="../../assets/annOnLine/notLink.png" />
            <p>输入PMID、DOI号、标题(大于60字符)可以直接获取全文</p>
        </div>
        <div class="viewMoreMsg" v-show="moreMsg">
            <span @click="chatPage">查看更多信息</span>
        </div>
        <ul class="dialog" ref="ananMain">
            <li v-for="(item, index) in dataList" :key="index">
                <!-- 用户提问 -->
                <!-- <div v-if="item['type'] == 0" class="user" v-html="item.data"></div> -->
                <div class="user" >
                    <span v-html="item.userRecord"></span>
                </div>

                <!-- 智能回答 -->
                <!-- <div v-if="item['type'] == 1"> -->
                    <div v-if="item['replyObject'].length>0">
                        <div v-if="item['type'] == '1' ||item['type'] == '2' ||item['type'] == '3' ||item['type'] == '5'" class="robot hdObj">
                            
                            <div v-for="(child,n) in item.replyObject" :key="n">
                                <div v-if="child.ti">
                                    <span>标题:</span><span v-html="child.ti"></span>
                                </div>
                                <div v-if="child.au">
                                    <span>作者:</span><span>{{ child.au }}</span>
                                </div>
                                <div v-if="child.doi">
                                    <span>DOI:</span><span>{{ child.doi }}</span>
                                </div>
                                <div v-if="child.so">
                                    <span>来源:</span><span>{{ child.so }}</span>
                                </div>
                                <div v-if="child.year">
                                    <span>出版年:</span><span>{{ child.year }}</span>
                                </div>
                                
                                <div v-if="item['type']==3">
                                    <span>全文链接:</span>
                                    <template v-if="child.zhPer==1||child.isZh==0">
                                        <button v-if="child.ispdf==0" @click="viewPdf(child)">申请全文</button>
                                        <button v-if="child.ispdf==1" @click="viewPdf(child)">点击查看</button>
                                        <button v-if="child.ispdf==1"  @click="copyLink" class="copybtn">复制链接</button>
                                    </template>
                                    <button class="zhwqxBtn" v-else>无权限，请联系管理员</button>
                                    
                                </div>
                                <div v-if="item['type']==5">
                                    <div v-if="child.pmid!=0 || child.url" >
                                        <span>全文链接:</span>
                                        <template v-if="child.zhPer==1||child.isZh==0">
                                            <button @click="viewPdf(child)">申请全文</button>
                                        </template>
                                        <button class="zhwqxBtn" v-else>无权限，请联系管理员</button>
                                        
                                    </div>
                                </div>
                                <div v-if="item['type']==1 || item['type']==2">
                                    <span>全文链接:</span>
                                    <template v-if="child.zhPer==1||child.isZh==0">
                                        <template v-if="child.url">
                                            <button @click="viewPdf(child)">点击查看</button>
                                            <button :data-clipboard-text="child.url" @click="copyLink" class="copybtn">复制链接</button>
                                        </template>
                                        <template v-if="!child.url && child.pmid!=0">
                                            <button @click="viewPdf(child)">申请全文</button>
                                        </template>
                                    </template>
                                    <button class="zhwqxBtn" v-else>无权限，请联系管理员</button>
                                    
                                </div>

                                </div>
                        </div>
                        <div v-if="item['type'] == '4'" class="robot hdArray">
                            <!-- 常见问题 -->
                            <ul>
                                <li v-for="(quItem, q) in item.replyObject" :key="q" @click="goDet(quItem.id)">{{ q + 1 }}.{{ quItem.answer }}</li>
                            </ul>
                        </div>
                    </div>
                    <div v-else>
                        <div class="robot hdArray">抱歉，没有找到答案</div>
                    </div>
                
                <!-- </div> -->
                
            </li>
        </ul>
        <div class="inputBox">
            <input placeholder="请输入PMID号、DOI号、标题(大于60字符)..." @keyup.enter="sendMsg" v-model="msgInput" />
            <!-- <img src="../../assets/annOnLine/chatlog.png" @click="gotoChatLog" /> -->
            <button @click="sendMsg">发送</button>
        </div>
    </div>
</template>

<script>
import annTab from "../../components/annTab";
import { Toast } from "vant";
import Clipboard from "clipboard";
export default {
    name: "annOnLine",
    data() {
        return {
            dataList: [],
            msgInput: "", //输入框的值
            linkFlag: true,
            userinfo: "",
            currentPage:1,//当前页面
            dwGd:0,
            moreMsg:false,
            wxType:0,
        };
    },
    components: {
        annTab
    },
    mounted() {
        // this.$myFun.routeQuery();
        this.getUserInfo();
        this.$store.dispatch("actionsHead", {
            type: true,
            title: "智能客服",
            iconType: false
        });
        this.chatRecord(0);
        this.is_weixin();
    },
    methods: {
        // 判断环境
        is_weixin() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //微信环境
                this.wxType=1;
            } else {
                this.wxType=0;
            }
        },
        // 请求用户信息
        getUserInfo() {
            this.$get("https://customer.yuntsg.com/login-user/get-user-info").then((res) => {
                if (res.code == 0) {
                    this.userInfo = {
                        userId: res.data.uid,
                        userName: res.data.realname,
                        userGid: res.data.gid
                    };
                } else {
                    // console.log("没有登录");
                }
            });
        },
        //发送消息
        async sendMsg() {
            this.linkFlag = false;
            // var qkgMsg = this.msgInput.replace(/\s+/g, "");
            var qkgMsg = this.msgInput.trim();
            var msgData={};
            if (qkgMsg.length <= 0) {
                Toast("请输入内容");
                return false;
            }
            msgData.userRecord=this.msgInput
            // var user = {
            //     type: 0,
            //     data: this.msgInput
            // };
            // this.dataList.push(user);
            await this.$get("https://customer.yuntsg.com/robot/robot?message=" + qkgMsg+'&type='+this.wxType).then(async (res) => {
                // console.log(res,'----res')
                // console.log(res.data,'----res.data')
                // for(var n in res.data){
                //     if(!res.data[n].pmid){
                //         res.data[n].pmid=0;
                //     }
                // }
                msgData.replyObject=res.data;
                
                msgData.type = res.code;
                    // var replyObject = {
                    //     type: 1,
                    //     childType: res.code,
                    //     data: res.data,
                    // };
                    this.dataList.push(msgData);
                    // console.log(this.dataList,'---');
                    this.msgInput = "";
                    this.zhidi();
            });
        },
        judgeField(val) {
            if (val) {
                return val;
            } else {
                return "";
            }
        },
        async fullText(data) {
            var list = [];
            var val = {};
            val.title = this.judgeField(data["ti"]);
            val.author = this.judgeField(data["au"]);
            val.sourcefrom = this.judgeField(data["so"]);
            val.doi = '';
            val.web = this.judgeField(data["web"]);
            val.url = "";
            val.pmid = this.judgeField(data["pmid"]) || 0;
            // val.pmid = 0;
            val.myid = this.judgeField(data["id"]);
            val.jid = '';
            val.pmidNcNlmId = '';
            val.sourcecode = "kf";
            list.push(val);
            var returnMsg = "";
            await this.$post("https://fulltext.yuntsg.com/cases/add", list).then((res) => {
                if(res.code==0 && res.data.result){
                returnMsg = '抱歉，暂未匹配到全文，已自动帮您申请文献，您可以点击“我的”—“我的文档”查看全文申请进度'
                }else{
                returnMsg= res.data.msg
                }
            });
            // Toast(returnMsg);
            Toast({
                message: returnMsg,
                duration: 4000,
            });     
            
        },

        //置底
        zhidi() {
            this.$nextTick(() => {
                const container = this.$el.querySelector(".dialog");
                if (container) document.documentElement.scrollTop = container.scrollHeight;
            });
        },
        //上次阅读位置
        readingPosition(){
            this.$nextTick(() => {
                const container = this.$el.querySelector(".dialog");
                if (container) document.documentElement.scrollTop = container.scrollHeight -this.dwGd - 100;
            });
        },
        goDet(id) {
            this.$router.push({ name: "problemDetails", params: { id: id } });
        },
        viewPdf(data) {
            var link = data.url;
            var flag = 1;
            if (data.ispdf == 0) {//申请
                flag = 0;
            }
            if (link && flag == 1) {
                Toast("打开中，请稍候");
                if (data.url && data.url.indexOf("http://s.get-sci.com") > -1) {
                     data.url = data.url.replace("http://s.get-sci.com", "https://s.pubtsg.com");
                }
                // console.log(data.url,'-----data.url')
                window.location.href = data.url;
            } else {
                this.fullText(data)
                // Toast("抱歉，全文打开失败");
            }
        },
        //聊天记录
        chatRecord(type) { 
            this.$get("https://customer.yuntsg.com/chat_record/select?size=10&page="+this.currentPage).then((res) => {
                if(res.data.records.length>0 && type==0){
                    this.linkFlag=false;//初始化的时候
                }
                if(res.data.total >= this.currentPage * 10 ){
                    this.moreMsg = true;
                }
                // console.log(this.moreMsg,'---this.moreMsg')
                if(type==1){
                    //分页在前面添加
                    this.dataList = res.data.records.concat(this.dataList);
                    this.readingPosition();
                }else{
                    
                    this.dataList = res.data.records;
                    
                    this.zhidi();
                } 

            })
        },
        //聊天记录分页
        chatPage(){
            this.dwGd = this.$el.querySelector(".dialog").scrollHeight;
            this.currentPage++;
            this.chatRecord(1);
        },
        // 复制链接
        copyLink() {
            console.log('复制链接')
            let clipboard = new Clipboard(".copybtn");
            clipboard.on("success", () => {
                Toast("复制成功");
                clipboard.destroy();
            });
            clipboard.on("error", () => {
                Toast("复制失败");
                clipboard.destroy();
            });
        }
    }
};
</script>
<style lang="less">
.annOnLine {
    background-color: #ffffff;
    color: #2f2f2f;
    font-size: 0.9rem;
    overflow: hidden;
    position: relative;
    width: 100%;
    padding-top: 5.5rem;
    .notLink {
        text-align: center;
        img {
            width: 10rem;
            margin-bottom: 1.5rem;
            margin-top: 5rem;
        }
        p {
            color: #a5a5a5;
        }
        .goMsg {
            color: #0689e7;
        }
    }
    .dialog {
        padding: 1rem;
        padding-bottom: 4rem;
        //对话框
        li {
            margin-bottom: 2rem;
            display: block;
            width: 100%;
            overflow: hidden;
        }
        .time {
            font-size: 0.8rem;
            color: #666666;
            margin-bottom: 0.4rem;
        }
        .input {
            display: inline-block;
            padding: 0.5rem;
            max-width: 70%;
            line-height: 1.4rem;
            text-align: left;
        }
        .user {            
            width: 100%;
            overflow: hidden;
            margin-bottom:1.5rem;
            // float: right;
            span{
                float: right;
                padding: 0.5rem 0.6rem;
                border-radius: 0.5rem 0rem 0.5rem 0.5rem;
                text-align: left;
                background-color: #2789e7;
                color: #fff;
                word-wrap: break-word;
                max-width: 80%;
            }
            a {
                color: #f9f508;
                border-bottom: 1px solid #f9f508;
            }
        }
        .robot {
            text-align: left;
            background-color: #f4f5f5;
            color: #000;
            padding: 0.5rem 0.6rem;
            border-radius: 0rem 0.5rem 0.5rem 0.5rem;
            max-width: 80%;
            float: left;
            word-wrap: break-word;
        }
        .robot >div{
            border-bottom: 1px solid #bfd9ed;
        }
        .robot >div:last-child{
            border-bottom: 0px;
        }
        .hdObj div {
            line-height: 1.4rem;
            margin-bottom: 0.5rem;
            button {
                color: #0073e2;
                border: 0.05333rem solid #0073e2;
                border-radius: 0.3rem;
                padding: 0rem 0.3rem;
                margin-left: 0.3rem;
                background-color: #ffffff;
            }
        }
        .hdArray ul li {
            color: #0073e2;
        }
    }
    .inputBox {
        width: 100%;
        height: 4rem;
        position: fixed;
        bottom: 0rem;
        left: 0rem;
        border-top: 1px solid #e5e9ee;
        padding: 0.7rem 0 0 1rem;
        background-color: #ffffff;
        input {
            background-color: #f5f5f5;
            height: 2.3rem;
            border-radius: 0.8rem 0 0 0.8rem;
            outline: none;
            border: none;
            padding: 0.5rem;
            width: 80%;
        }
        img {
            height: 1.7rem;
            margin: -0.2rem 0.4rem 0 -0.5rem;
            vertical-align: middle;
        }
        button {
            border: none;
            background-color: #0689e7;
            color: #ffffff;
            width: 15%;
            height: 2.3rem;
            border-radius: 0 0.8rem 0.8rem 0;
        }
    }
    //查看更多消息
    .viewMoreMsg{
        // display: none;
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 1.5rem;
    }
    .zhwqxBtn{
        color: #768c97 !important;
        border: 1px solid !important;
        background-color:#e5e5e5 !important;
    }
}
</style>
